import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { DeactivateIcon } from 'assets/materialIcons/materialIcons';
import { closeModal, openConfirmModal, modalStartLoading } from 'store/actions/modalActions';
import { connect } from 'react-redux';

class DeleteModalButton extends React.Component {
    constructor() {
        super();

        this.sendRequest = this.sendRequest.bind(this);
    }

    setEvents = () => {
        const {
            openModal,
            showLoader,
            translate,
        } = this.props;

        openModal({
            actions: {
                submit: () => {
                    showLoader();

                    this.sendRequest();
                },
            },
            content: {
                description: translate('elements.delete.description'),
            },
            title: translate('elements.delete.title'),
        });
    }

    sendRequest = () => {
        const {
            additional,
            id,
            resource,
            sendFailure,
            sendSuccess,
            shouldRedirectToResourceList,
        } = this.props;

        const url = `${ config.getApiBaseUrl() }/${ resource }/${ id }${ additional ? `/${ additional }` : '' }`;

        return apiClient.delete(url).then(() => {
            if (shouldRedirectToResourceList) {
                window.location.href = `/${ resource }`;
            }

            sendSuccess({
                id: id,
            });
        }, (error) => {
            sendFailure(error);
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        return (
            <Button
                icon={ <DeactivateIcon color={ theme.palette.redOrange } style={ { transform: 'rotate(45deg)' } } /> }
                onClick={ this.setEvents }
                title={ translate('actions.delete') }
            />
        );
    }
}

DeleteModalButton.defaultProps = {
    shouldRedirectToResourceList: true,
};

DeleteModalButton.propTypes = {
    additional: PropTypes.string,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    openModal: PropTypes.func.isRequired,
    resource: PropTypes.string.isRequired,
    sendFailure: PropTypes.func.isRequired,
    sendSuccess: PropTypes.func.isRequired,
    showLoader: PropTypes.func.isRequired,
    shouldRedirectToResourceList: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, props) => {
    const { failureAction, successAction } = props;

    return {
        openModal: (payload) => {
            dispatch(openConfirmModal(payload));
        },
        showLoader: () => {
            dispatch(modalStartLoading());
        },
        sendFailure: (error) => {
            dispatch(closeModal());

            dispatch(failureAction(error));
        },
        sendSuccess: (response) => {
            dispatch(closeModal());

            dispatch(successAction(response));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(DeleteModalButton);



// WEBPACK FOOTER //
// ./src/components/button/DeleteModalButton.js